import { render, staticRenderFns } from "./WidgetsGrid.vue?vue&type=template&id=64e797ae&scoped=true&"
import script from "./WidgetsGrid.vue?vue&type=script&lang=js&"
export * from "./WidgetsGrid.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsGrid.vue?vue&type=style&index=0&id=64e797ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e797ae",
  null
  
)

export default component.exports